import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { setCustomer } from "../../Redux/Action/getcustomerAction";
import { home_icon, office_icon, OtherTag } from "../../assets";
import { toast } from "react-toastify";
import { detectWebDeviceType, isTablet } from "../../utils";
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";

function InputField({
  label,
  placeholder,
  changed,
  inputType,
  error,
  readOnly,
  onFocus,
  focused,
  ...props
}) {
  const deviceType = detectWebDeviceType();
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="mt-4 mb-2 font-medium max-md:max-w-full">{label}</div>
      <div
        className={`flex border border-solid rounded-xl overflow-hidden justify-center items-start ${
          inputType === "number" && i18n.language === "ar"
            ? "flex-row-reverse"
            : ""
        }${deviceType === "tablet" && focused ? "border-[#1B459760]" : ""}`}
      >
        {inputType === "number" && (
          <span className="pl-3 py-3 bg-white text-black max-md:pe-3">
            {i18n.language === "ar" ? "20+" : "+20"}
          </span>
        )}
        <input
          {...props}
          type="text"
          placeholder={placeholder}
          readOnly={readOnly}
          onFocus={onFocus}
          style={{ direction: inputType === "number" && "ltr" }}
          onChange={(text) => changed(text)}
          className={`p-3 rounded-xl border-0 border-neutral-400 border-opacity-50 text-black max-md:pr-5 max-md:max-w-full w-full focus:outline-none focus:border-1px ${
            inputType === "text" ? "bg-gray-100" : "bg-white"
          } ${error ? "border-red-500" : ""}`}
        />
      </div>
    </>
  );
}

function InputAdd({
  label,
  placeholder,
  changed,
  inputType,
  error,
  readOnly,
  onFocus,
  focused,
  ...props
}) {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  return (
    <>
      <div className="flex flex-col">
        <div className="mt-5 mb-2 font-medium max-md:max-w-full">{label}</div>
        <div
          className={`flex border border-solid rounded-xl overflow-hidden justify-center items-start ${
            inputType === "number" && i18n.language === "ar"
              ? "flex-row-reverse"
              : ""
          }${deviceType === "tablet" && focused ? "border-[#1B459760]" : ""}`}
        >
          <input
            {...props}
            type="text"
            placeholder={placeholder}
            readOnly={readOnly}
            onFocus={onFocus}
            style={{ direction: inputType === "number" && "ltr" }}
            onChange={(text) => changed(text)}
            className={`p-3 rounded-xl border-0 border-neutral-400 border-opacity-50 text-black max-md:pr-5 max-md:max-w-full w-full focus:outline-none focus:border-1px ${
              inputType === "text" ? "bg-white" : "bg-white"
            } ${error ? "border-red-500" : ""}`}
          />
        </div>
      </div>
    </>
  );
}

function AddCustomer_Modal({
  onClose,
  confirm,
  showSkipButton,
  isAddressMandatory,
}) {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  const [mobile, setMobile] = useState("");
  const [userName, setName] = useState("");
  const [addField1, setaddField1] = useState("");
  const [addField2, setaddField2] = useState("");
  const [addField3, setaddField3] = useState("");
  const [addField4, setaddField4] = useState("");

  const [displayName, setDisplayName] = useState("");
  const [customerExist, setCutomerExist] = useState(false);
  const [clickDisable, setClickDisable] = useState(false);
  const [partnerId, setPartnerId] = useState("");
  const { user_id } = useSelector((state) => state?.login?.user?.result);
  const inputRef = useRef(null);
  const [addressTypes, setAddressTypes] = useState([]);
  const [selectedAddressType, setSelectedAddressType] = useState(null);
  const paymentReducer = useSelector((state) => state?.paymentReducer);
  const getCustomerState = useSelector((state) => state.getcustomer);
  const { selectedCustomer } = getCustomerState;
  const [suggestions, setSuggestions] = useState([]);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [searchMode, setSearchMode] = useState("");
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric");
  const [focusedField, setFocusedField] = useState(""); // 'amount' or 'reason'
  const [keyboardHeight, setKeyboardHeight] = useState(false);

  const handleCustomKeyPress = (key) => {
    console.log("key =>", key);
    if (focusedField == "mobile") {
      if (key === "DEL") {
        setMobile((prev) => {
          const updated = prev.slice(0, -1);
          handleCustomerMobile(updated, true); // also update here
          return updated;
        });
        return;
      }

      // Handle SPACE
      if (key === "SPACE") {
        setMobile((prev) => {
          const updated = prev + " ";
          handleCustomerMobile(updated, true);
          return updated;
        });
        return;
      }

      // Handle regular keys (digits/letters/symbols)
      setMobile((prev) => {
        const updated = prev + key;
        handleCustomerMobile(updated, true);
        return updated;
      });
    } else if (focusedField == "name") {
      if (key === "DEL") {
        setDisplayName((prev) => {
          const updated = prev.slice(0, -1);
          handleCustomerSearch(updated, false); // also update here
          return updated;
        });
        return;
      }

      // Handle SPACE
      if (key === "SPACE") {
        setDisplayName((prev) => {
          const updated = prev + " ";
          handleCustomerSearch(updated, false);
          return updated;
        });
        return;
      }

      // Handle regular keys (digits/letters/symbols)
      setDisplayName((prev) => {
        const updated = prev + key;
        handleCustomerSearch(updated, false);
        return updated;
      });
    } else if (focusedField == "addField1") {
      if (key === "DEL") {
        setaddField1((prev) => {
          const updated = prev.slice(0, -1);
          return updated;
        });
        return;
      }

      // Handle SPACE
      if (key === "SPACE") {
        setaddField1((prev) => {
          const updated = prev + " ";
          return updated;
        });
        return;
      }

      // Handle regular keys (digits/letters/symbols)
      setaddField1((prev) => {
        const updated = prev + key;
        return updated;
      });
    } else if (focusedField == "addField2") {
      if (key === "DEL") {
        setaddField2((prev) => {
          const updated = prev.slice(0, -1);
          return updated;
        });
        return;
      }

      // Handle SPACE
      if (key === "SPACE") {
        setaddField2((prev) => {
          const updated = prev + " ";
          return updated;
        });
        return;
      }

      // Handle regular keys (digits/letters/symbols)
      setaddField2((prev) => {
        const updated = prev + key;
        return updated;
      });
    } else if (focusedField == "addField3") {
      if (key === "DEL") {
        setaddField3((prev) => {
          const updated = prev.slice(0, -1);
          return updated;
        });
        return;
      }

      // Handle SPACE
      if (key === "SPACE") {
        setaddField3((prev) => {
          const updated = prev + " ";
          return updated;
        });
        return;
      }

      // Handle regular keys (digits/letters/symbols)
      setaddField3((prev) => {
        const updated = prev + key;
        return updated;
      });
    } else if (focusedField == "addField4") {
      if (key === "DEL") {
        setaddField4((prev) => {
          const updated = prev.slice(0, -1);
          return updated;
        });
        return;
      }

      // Handle SPACE
      if (key === "SPACE") {
        setaddField4((prev) => {
          const updated = prev + " ";
          return updated;
        });
        return;
      }

      // Handle regular keys (digits/letters/symbols)
      setaddField4((prev) => {
        const updated = prev + key;
        return updated;
      });
    }
  };

  useEffect(() => {
    // Check if selectedCustomer is an object or a string
    if (typeof selectedCustomer === "string") {
      // If it's a string, treat it as a mobile number
      handleCustomerMobile(selectedCustomer);
    } else if (selectedCustomer && selectedCustomer.mobile) {
      // If it's an object, check if the fields are empty
      const { add_field_1, add_field_2, add_field_3, add_field_4 } =
        selectedCustomer;

      if (!add_field_1 && !add_field_2 && !add_field_3 && !add_field_4) {
        // Fill the mobile number in the field
        console.log("selectedCustomer", selectedCustomer);

        handleCustomerMobile(selectedCustomer.mobile);
      }
    }
  }, [selectedCustomer]);

  let paymentMethod = null;

  // Check if paymentReducer is a string or an object
  if (typeof paymentReducer === "string") {
    try {
      paymentMethod = JSON.parse(paymentReducer).selectedPaymentMethod;
    } catch (error) {
      console.error("Error parsing paymentReducer:", error);
    }
  } else if (typeof paymentReducer === "object") {
    paymentMethod = paymentReducer.selectedPaymentMethod;
  }

  const [hasError, setHasError] = useState({
    mobile: false,
    displayName: false,
  });

  let len = 10;

  if (/^0/.test(mobile)) {
    len = 11;
  }

  useEffect(() => {
    const fetchAddressTypes = async () => {
      try {
        const url =
          axiosInstance.defaults.baseURL === "https://uat.myginne.com/V2"
            ? URLS.GET_ADDRESS_TYPES
            : URLS.GET_ADDRESS_TYPES_2;

        const response = await axiosInstance.post(url, {});

        if (response?.data?.result?.[0]?.status_code === 200) {
          const translatedAddressTypes = response.data.result[0].response.map(
            (address) => ({
              id: address.id,
              name: t(address.name), // Translate the address name
            })
          );
          setAddressTypes(translatedAddressTypes);
          // setAddressTypes(response.data.result[0].response || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchAddressTypes();
  }, []);

  const CreateCustomer = async (values) => {
    try {
      const response = await axiosInstance.post(URLS.CREATE_CUSTOMER, {
        // mobile: values?.mobile,
        mobile: values.mobile?.replace(/^0+/, ""),
        name: values?.name,
        email: "",
        user_id: user_id,
        address_type_id: values?.address_type,
        add_field_1: values?.addField1,
        add_field_2: values?.addField2,
        add_field_3: values?.addField3,
        add_field_4: values?.addField4,
      });

      if (response?.data?.result?.status_code === 200) {
        setPartnerId(response?.data.result.partner_id);

        let customer = {
          partnerId: response?.data.result.partner_id,
          userName: values?.name,
          mobile: values?.mobile?.replace(/^0+/, ""),
          address_type_id: values?.address_type,
          add_field_1: values?.addField1,
          add_field_2: values?.addField2,
          add_field_3: values?.addField3,
          add_field_4: values?.addField4,
        };
        confirm(customer);
      } else if (
        response?.data?.result?.status === "Customer already Available"
      ) {
        toast.error(t("Customer already exist with this phone number"));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const UpdateCustomer = async (values) => {
    // console.log("selectedAddressType",selectedAddressType);

    try {
      const response = await axiosInstance.post(URLS.UPDATE_CUSTOMER_DATA, {
        mobile: values.mobile?.replace(/^0+/, ""),
        name: values.name,
        email: "",
        user_id: user_id,
        address_type_id: selectedAddressType?.id,
        // address_type_id: selectedAddressType?.type_id,
        add_field_1: values?.addField1,
        add_field_2: values?.addField2,
        add_field_3: values?.addField3,
        add_field_4: values?.addField4,
      });
      // console.log("update data", response);
      if (response?.data) {
        let customer = {
          partnerId: partnerId,
          userName: userName,
          mobile: mobile,
          address_type_id: selectedAddressType?.id,
          add_field_1: values?.addField1,
          add_field_2: values?.addField2,
          add_field_3: values?.addField3,
          add_field_4: values?.addField4,
        };
        confirm(customer);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // console.log("RESS ADD", selectedAddressType);

  const handleConfirm = async () => {
    // let values = { mobile, name: displayName };
    if (mobile.length < 10) {
      toast.error(t("Please enter valid phone number"));
      return;
    }

    if (isAddressMandatory && !selectedAddressType?.id) {
      toast.error(t("Please enter the address"));
      return;
    }

    if (
      selectedAddressType?.id &&
      (addField1 == "" || addField2 == "" || addField3 == "")
    ) {
      toast.error("Please enter complete address");
      return;
    }

    let values = {
      mobile,
      name: displayName,
      address_type: selectedAddressType?.id,
      addField1,
      addField2,
      addField3,
      addField4,
    };

    // console.log("ADD", houseNo, groupNo, street, additionalAddressInfo, company, floor, building, apartmentNo, buildingGroup, additionalInfo);

    setHasError({ mobile: false, displayName: false });

    if (!mobile) {
      setHasError({
        mobile: !mobile,
      });
      return;
    }

    if (customerExist) {
      await UpdateCustomer(values);
    } else {
      await CreateCustomer(values);
    }
  };

  const handleCustomerMobile = async (value, search) => {
    // Start searching after 3 characters
    console.log("DDDADDA1");

    if (value.length >= 4) {
      let payloads = { user_id: user_id };

      // Check if the input is numeric (for phone number) or alphabetic (for name)
      if (/^\d+$/.test(value)) {
        // If it's a number, clean it and add to payload
        const cleanedValue = value.replace(/^0+/, ""); // Remove leading zeros
        payloads.mobile = cleanedValue; // Add mobile to payload
      } else {
        // If it's not a number, treat it as a name
        payloads.name = value; // Add name to payload
      }

      try {
        const response = await axiosInstance.post(URLS.GET_CUSTOMER_DETAILS,
          payloads
        );

        // Handle the response
        if (response?.data?.result?.status_code === 200) {
          const partnersDetails = response.data.result.partners_details || []; // Default to an empty array if undefined

          // Set suggestions based on the response
          setSuggestions(partnersDetails); // Set suggestions to the array of partners
          // console.log("DDDADDA2", partnersDetails);
          if (partnersDetails?.length < 2 && !search) {
            handleSuggestionClick(partnersDetails[0]);
          }
        } else {
          // Clear suggestions if the status is not 200
          setSuggestions([]);
          // console.log("DDDADDA3");
        }
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const clearData = () => {
    setMobile(""); // Set the mobile number
    setName(""); // Set the name
    setDisplayName(""); // Set the display name
    setCutomerExist(false); // Mark customer as existing
    setPartnerId(""); // Set the partner ID
    setaddField1("");
    setaddField2("");
    setaddField3("");
    setaddField4("");

    const defaultAddressTypes = [
      { id: 1, name: t("Villa") },
      { id: 2, name: t("Office") },
      { id: 3, name: t("Apartment") },
    ];
    setAddressTypes(defaultAddressTypes);

    setSelectedAddressType(null); // Set to Villa
    setInputDisabled(false);
  };

  const handleSuggestionClick = (customer) => {
    setMobile(customer.phone); // Set the mobile number
    setName(customer.name); // Set the name
    setDisplayName(customer.name); // Set the display name
    setCutomerExist(true); // Mark customer as existing
    setPartnerId(customer.id); // Set the partner ID

    const addresses = customer.addresses || []; // Get addresses

    // If addresses are found, set the address types
    if (addresses.length > 0 && addresses[0]?.type_id != false) {
      setAddressTypes(
        addresses.map((address) => ({
          id: address.type_id,
          name: t(address.name),
        }))
      );

      // Optionally, set the selected address type and additional fields
      const defaultAddressType = addresses[0];
      setSelectedAddressType(defaultAddressType);
      setaddField1(defaultAddressType.add_field_1);
      setaddField2(defaultAddressType.add_field_2);
      setaddField3(defaultAddressType.add_field_3);
      setaddField4(defaultAddressType.add_field_4);
      let add = {
        id: addresses[0]?.type_id,
        name: addresses[0]?.name,
      };
      handleOpenClick(add);
      setInputDisabled(true);
    } else {
      // If no addresses are found, set default address types
      setInputDisabled(true);
      setAddressTypes([
        { id: 1, name: t("Villa") },
        { id: 2, name: t("Office") },
        { id: 3, name: t("Apartment") },
      ]);
      setaddField1("");
      setaddField2("");
      setaddField3("");
      setaddField4("");
    }

    setClickDisable(true); // Enable or disable the button based on your logic
    setSuggestions([]); // Clear suggestions after selection
  };

  const handleCustomerSearch = async (value, isMobileSearch) => {
    if (value.length >= 3) {
      let payloads = { user_id: user_id };
      if (isMobileSearch) {
        const cleanedValue = value.replace(/^0+/, ""); // Clean leading zeros
        payloads.mobile = cleanedValue; // Add mobile to payload
      } else {
        payloads.name = value; // Add name to payload
      }

      try {
        const response = await axiosInstance.post(URLS.GET_CUSTOMER_DETAILS,
          payloads
        );

        if (response?.data?.result?.status_code === 200) {
          const partnersDetails = response.data.result.partners_details || [];
          setSuggestions(partnersDetails); // Set suggestions based on the response
        } else {
          setSuggestions([]);
        }
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    } else {
      setSuggestions([]); // Clear suggestions if input is less than 3 characters
    }
  };

  const isAddressFieldsEmpty = () => {
    return !addField1 && !addField2 && !addField3 && !addField4;
  };

  const handleSkip = () => {
    confirm({ skip: true });
    onClose();
  };

  const handleClick = (address) => {
    // console.log("DDDDDD", address);
    setKeyboardHeight(true);
    setSelectedAddressType(address);
    if (!clickDisable) {
      setaddField1("");
      setaddField2("");
      setaddField3("");
      setaddField4("");
    }
    renderAddressFields();
  };

  const handleOpenClick = (address) => {
    // console.log("DDDDDD", address);

    setSelectedAddressType(address);
    // if (!clickDisable) {
    //   setaddField1("");
    //   setaddField2("");
    //   setaddField3("");
    //   setaddField4("");
    // }
    renderAddressFields();
  };

  const handleKeyDown = (e) => {
    const normalizedKey =
      {
        // "ش": "Enter", // Arabic "ش" is similar to English "Enter"
        إ: "Shift", // Arabic "إ" is similar to English "Shift"
        Esc: "Escape", // Arabic "Esc" is similar to English "Escape"
      }[e.key] || e.key; // Fallback to the original key if no mapping exists

    if (e.key === "Enter") {
      e.preventDefault();
      // setHasError({displayName: false });
      if (!displayName) {
        setHasError({ ...hasError, displayName: true });
      } else {
        setHasError({ ...hasError, displayName: false });
        handleConfirm();
      }
    } else if (e.shiftKey && showSkipButton && normalizedKey === "Shift") {
      e.preventDefault(); // Ensure that the Shift key combination is handled
      handleSkip();
    } else if (normalizedKey === "Escape") {
      e.preventDefault();
      onClose();
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    displayName,
    hasError,
    showSkipButton,
    handleConfirm,
    handleSkip,
    onClose,
  ]);

  const renderAddressFields = () => {
    if (!selectedAddressType) return null;
    // console.log("selectedAddressType", selectedAddressType);

    switch (selectedAddressType?.id) {
      case 1:
        return (
          <>
            <div className="flex ">
              <div
                style={
                  i18n.language === "ar"
                    ? { marginLeft: 16 }
                    : { marginRight: 16 }
                }
              >
                <InputAdd
                  label={t("House No. / Villa No.")}
                  inputType="text"
                  value={addField1}
                  readOnly={deviceType === "tablet"} // only readOnly on tablet
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setShowKeyboard(true);
                      setFocusedField("addField1");
                    }
                  }}
                  focused={focusedField === "addField1"}
                  changed={(e) => setaddField1(e.target.value)}
                />
              </div>

              <InputAdd
                label={t("Group No.")}
                inputType="text"
                value={addField2}
                readOnly={deviceType === "tablet"} // only readOnly on tablet
                onFocus={() => {
                  if (deviceType === "tablet") {
                    setKeyboardMode("alphanumeric");
                    setShowKeyboard(true);
                    setFocusedField("addField2");
                  }
                }}
                focused={focusedField === "addField2"}
                changed={(e) => setaddField2(e.target.value)}
              />
            </div>
            <div className="flex">
              <div
                style={
                  i18n.language === "ar"
                    ? { marginLeft: 16 }
                    : { marginRight: 16 }
                }
              >
                <InputAdd
                  label={t("Street")}
                  inputType="text"
                  value={addField3}
                  readOnly={deviceType === "tablet"} // only readOnly on tablet
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setShowKeyboard(true);
                      setFocusedField("addField3");
                    }
                  }}
                  focused={focusedField === "addField3"}
                  changed={(e) => setaddField3(e.target.value)}
                />
              </div>

              <InputAdd
                label={t("Additional Information")}
                inputType="text"
                value={addField4}
                readOnly={deviceType === "tablet"} // only readOnly on tablet
                onFocus={() => {
                  if (deviceType === "tablet") {
                    setKeyboardMode("alphanumeric");
                    setShowKeyboard(true);
                    setFocusedField("addField4");
                  }
                }}
                focused={focusedField === "addField4"}
                changed={(e) => setaddField4(e.target.value)}
              />
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="flex ">
              <div
                style={
                  i18n.language === "ar"
                    ? { marginLeft: 16 }
                    : { marginRight: 16 }
                }
              >
                <InputAdd
                  label={t("Company")}
                  inputType="text"
                  value={addField1}
                  readOnly={deviceType === "tablet"} // only readOnly on tablet
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setShowKeyboard(true);
                      setFocusedField("addField1");
                    }
                  }}
                  focused={focusedField === "addField1"}
                  changed={(e) => setaddField1(e.target.value)}
                />
              </div>

              <InputAdd
                label={t("Floor")}
                inputType="text"
                value={addField2}
                readOnly={deviceType === "tablet"} // only readOnly on tablet
                onFocus={() => {
                  if (deviceType === "tablet") {
                    setKeyboardMode("alphanumeric");
                    setShowKeyboard(true);
                    setFocusedField("addField2");
                  }
                }}
                focused={focusedField === "addField2"}
                changed={(e) => setaddField2(e.target.value)}
              />
            </div>
            <div className="flex ">
              <div
                style={
                  i18n.language === "ar"
                    ? { marginLeft: 16 }
                    : { marginRight: 16 }
                }
              >
                <InputAdd
                  label={t("Building")}
                  inputType="text"
                  value={addField3}
                  readOnly={deviceType === "tablet"} // only readOnly on tablet
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setShowKeyboard(true);
                      setFocusedField("addField3");
                    }
                  }}
                  focused={focusedField === "addField3"}
                  changed={(e) => setaddField3(e.target.value)}
                />
              </div>

              <InputAdd
                label={t("Additional Information")}
                inputType="text"
                value={addField4}
                readOnly={deviceType === "tablet"} // only readOnly on tablet
                onFocus={() => {
                  if (deviceType === "tablet") {
                    setKeyboardMode("alphanumeric");
                    setShowKeyboard(true);
                    setFocusedField("addField4");
                  }
                }}
                focused={focusedField === "addField4"}
                changed={(e) => setaddField4(e.target.value)}
              />
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div className="flex ">
              <div
                style={
                  i18n.language === "ar"
                    ? { marginLeft: 16 }
                    : { marginRight: 16 }
                }
              >
                <InputAdd
                  label={t("Building & Group")}
                  inputType="text"
                  value={addField1}
                  readOnly={deviceType === "tablet"} // only readOnly on tablet
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setShowKeyboard(true);
                      setFocusedField("addField1");
                    }
                  }}
                  focused={focusedField === "addField1"}
                  changed={(e) => setaddField1(e.target.value)}
                />
              </div>

              <InputAdd
                label={t("Apartment No.")}
                inputType="text"
                value={addField2}
                readOnly={deviceType === "tablet"} // only readOnly on tablet
                onFocus={() => {
                  if (deviceType === "tablet") {
                    setKeyboardMode("alphanumeric");
                    setShowKeyboard(true);
                    setFocusedField("addField2");
                  }
                }}
                focused={focusedField === "addField2"}
                changed={(e) => setaddField2(e.target.value)}
              />
            </div>
            <div className="flex ">
              <div
                style={
                  i18n.language === "ar"
                    ? { marginLeft: 16 }
                    : { marginRight: 16 }
                }
              >
                <InputAdd
                  label={t("Floor")}
                  inputType="text"
                  value={addField3}
                  readOnly={deviceType === "tablet"} // only readOnly on tablet
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");
                      setShowKeyboard(true);
                      setFocusedField("addField3");
                    }
                  }}
                  focused={focusedField === "addField3"}
                  changed={(e) => setaddField3(e.target.value)}
                />
              </div>

              <InputAdd
                label={t("Additional Information")}
                inputType="text"
                value={addField4}
                readOnly={deviceType === "tablet"} // only readOnly on tablet
                onFocus={() => {
                  if (deviceType === "tablet") {
                    setKeyboardMode("alphanumeric");
                    setShowKeyboard(true);
                    setFocusedField("addField4");
                  }
                }}
                focused={focusedField === "addField4"}
                changed={(e) => setaddField4(e.target.value)}
              />
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const getIcon = (address) => {
    // console.log("address",address);

    switch (address) {
      case 1:
        return home_icon;
      case 2:
        return office_icon;
      case 3:
        return OtherTag;
      default:
        return null;
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (e.target.name === "mobile") {
      setMobile(value.replace(/[^0-9]/g, "")); // Allow only numbers
      handleCustomerSearch(value.replace(/[^0-9]/g, ""), true); // Search by mobile
    } else if (e.target.name === "name") {
      setDisplayName(value);
      handleCustomerSearch(value, false); // Search by name
    }
  };

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
        <section
          className={` flex flex-col font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 z-40 ${
            deviceType === "tablet" ? "px-12 py-12" : "px-12 py-12"
          } ${
            deviceType === "tablet" ? "fixed left-20" : "relative "
          } max-md:px-5 text-lg`}
          style={{
            width: deviceType === "tablet" ? "700px" : "700px",
          }}
        >
          <header className="flex gap-5 text-3xl max-md:flex-wrap max-md:max-w-full">
            <h1
              className={`my-auto ${
                deviceType === "tablet" ? "flex-auto text-xl" : "flex-auto "
              }`}
            >
              {t("Add Customer")}
            </h1>
            <button
              type="button"
              onClick={onClose}
              className="text-zinc-800 absolute top-5 right-5 bg-transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </header>
          <main>
            <InputField
              ref={inputRef}
              autoFocus={true}
              // readOnly={inputDisabled}
              type={"text"}
              inputType={"text"}
              name="mobile"
              readOnly={deviceType === "tablet"} // only readOnly on tablet
              onFocus={() => {
                if (deviceType === "tablet") {
                  setKeyboardMode("numeric");
                  setShowKeyboard(true);
                  setFocusedField("mobile");
                  setSearchMode("mobile");
                }
              }}
              focused={focusedField === "mobile"}
              label={t("Enter phone number")}
              value={mobile}
              // changed={handleInputChange}
              changed={(e) => {
                setSearchMode("mobile");
                if (e.target.value === "") {
                  setMobile("");
                  setName("");
                }
                const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                let maxLength = 10;

                if (/^0/.test(inputValue)) {
                  maxLength = 11;
                }
                if (inputValue.length < 10) {
                  setDisplayName("");
                  setName("");
                }
                if (
                  /^\d*$/.test(inputValue) &&
                  inputValue.length <= maxLength
                ) {
                  setMobile(inputValue);
                  handleCustomerMobile(inputValue, true);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && mobile?.length === 10) {
                  e.preventDefault();
                  handleConfirm();
                }
              }}
            />
            {searchMode === "mobile" &&
              mobile.length > 3 &&
              suggestions.length > 0 && (
                <div className="absolute z-10 mt-1 w-[86%] bg-white border border-gray-300 rounded-lg shadow-lg">
                  <div className="max-h-60 overflow-y-auto">
                    {suggestions.map((customer) => (
                      <div
                        key={customer.id} // Assuming each customer has a unique id
                        onClick={() => handleSuggestionClick(customer)} // Handle click on suggestion
                        className="cursor-pointer p-2 hover:bg-gray-100 border-b-4 transition duration-200"
                      >
                        {customer.phone === customer.name
                          ? customer.phone
                          : `${customer.phone} - ${customer.name}`}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            <InputField
              label={t("Enter Name")}
              inputType={"text"}
              value={displayName}
              name="name"
              // readOnly={inputDisabled}
              readOnly={deviceType === "tablet"} // only readOnly on tablet
              onFocus={() => {
                if (deviceType === "tablet") {
                  setKeyboardMode("alphanumeric");
                  setShowKeyboard(true);
                  setFocusedField("name");
                  setSearchMode("name"); // set active input
                }
              }}
              focused={focusedField === "name"}
              changed={(e) => {
                setSearchMode("name"); // set active input
                handleInputChange(e);
              }}
              maxLength={30}
            />
            {inputDisabled && (
              <span
                className="flex justify-end font-normal text-blue-900 cursor-pointer mt-2 me-2 "
                onClick={clearData}
              >
                {" "}
                {t("Clear")}{" "}
              </span>
            )}
            {searchMode === "name" &&
              displayName.length >= 3 &&
              suggestions.length > 0 && (
                <div className="absolute z-10 mt-1 w-[86%] bg-white border border-gray-300 rounded-lg shadow-lg">
                  <div className="max-h-60 overflow-y-auto">
                    {suggestions.map((customer) => (
                      <div
                        key={customer.id} // Assuming each customer has a unique id
                        onClick={() => handleSuggestionClick(customer)} // Handle click on suggestion
                        className="cursor-pointer p-2 hover:bg-gray-100 border-b-4 transition duration-200"
                      >
                        {customer.phone === customer.name
                          ? customer.phone
                          : `${customer.phone} - ${customer.name}`}
                        {/* {customer.name} - {customer.phone}{" "} */}
                        {/* Display name and phone */}
                      </div>
                    ))}
                  </div>
                  <div
                    onClick={() => {
                      setSuggestions([]); // Clear suggestions
                    }}
                    className="cursor-pointer p-2 italic text-blue-700 font-normal hover:bg-gray-100 transition duration-200"
                  >
                    {t("Create")}
                  </div>
                </div>
              )}

            {/* Display Address Types */}
          <span
  className={`flex justify-start  ${
    deviceType === "tablet" ? "text-m mt-6" : "mt-8"
  }`}
>
  {" "}
  {t("Add Address")}{" "}
</span>
  <p className="text-base text-amber-600 mt-1 font-normal">
    {t("For delivery orders, please enter the delivery address.")}
  </p>
            <div className="flex justify-start mt-2 ">
              {addressTypes.map((address, index) => (
                <button
                  key={address.id}
                  onClick={() => {
                    handleClick(address);
                  }}
                  className={`px-4 py-2 rounded-lg border  outline-none focus:outline-none bg-transparent ${
                    selectedAddressType?.id === address.id
                      ? "text-[#1B4597] bg-gray border-[#1B4597] border-solid"
                      : "bg-white border border-solid border-stone-300 text-zinc-600"
                  } flex items-center`}
                  style={{
                    ...(i18n.language === "ar"
                      ? { marginLeft: 16 }
                      : { marginRight: 16 }),
                  }}
                >
                  {getIcon(address.id) && (
                    <img
                      src={getIcon(address.id)}
                      alt={`${address.name} icon`}
                      className="w-6 h-6 me-2"
                    />
                  )}
                  {address.name}
                </button>
              ))}
            </div>

            {renderAddressFields()}
          </main>
          <footer className="flex justify-between gap-0 items-center ">
            {showSkipButton && (
              <button
                onClick={handleSkip}
                className={`justify-center items-center mt-6 px-16 py-3.5 text-xl text-center text-[#7EC242] rounded-lg border-2 border-[#7EC242] border-solid capitalize whitespace-nowrap bg-white rounded-lg max-md:px-5 max-md:max-w-full me-3.5
 `}
                style={{ width: "500px" }}
              >
                {t("Skip")}
              </button>
            )}
            <button
              disabled={
                (paymentMethod?.name === "Delivery" &&
                  isAddressFieldsEmpty()) ||
                mobile.length === 0 ||
                mobile.length !== len
              }
              onClick={handleConfirm}
              className={`justify-center mt-6 items-center px-16 py-3.5 text-xl text-center text-white capitalize whitespace-nowrap bg-[#7EC242] rounded-lg max-md:px-5 max-md:max-w-full 
`}
              style={{
                width: "600px",
                opacity:
                  (paymentMethod?.name === "Delivery" &&
                    isAddressFieldsEmpty()) ||
                  mobile.length === 0 ||
                  mobile.length !== len
                    ? 0.5
                    : 1,
              }}
              //   opacity: mobile.length > 0 && mobile.length === len ? 1 : 0.5,
              // }}
            >
              {t("Confirm")}
            </button>
          </footer>
        </section>
        {deviceType === "tablet" && showKeyboard && (
          <AlphaNumericKeyboardModal
            onClose={() => setShowKeyboard(false)}
            onKeyPress={handleCustomKeyPress}
            mode={keyboardMode}
            width="42%"
            maxWidth="42%"
            maxHeight="48%"
            // height="90%"
            // maxHeight={keyboardHeight == true ? "72%" : "50%"}
          />
        )}
      </div>
    </>
  );
}

export default AddCustomer_Modal;
